import React from "react";
import CSVReader from 'react-csv-reader'
import {Button, Card, Col, Form, Input, message, Modal, Row, Select, Spin, Table} from 'antd'
import {API, Auth, Storage} from "aws-amplify"
import "../../Styles/Services/checkInvoiceCSV.css"
import {connect} from "react-redux";
import {allDispatch as mapDispatchToProps, allState as mapStateToProps} from "../../Redux/Selectors";
import {withRouter} from "react-router-dom";
import {CustomSpinner} from "../../Components/Spin/CustomSpiner";
import BaseAdminLite from "./BaseAdminLite";
import moment from "moment";


class LoadUsersBatch extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            step: 'newBatch',
            loteIdView: null,
            nuevoLoteId: '',
            uploadingCsv: false,
            enableUpload: true,
            pagination: {},
            data: null,
            csv: [],
            selectedKeys: [],
            modalVisible: false,
            indexEditing: null,
            recordEditing: null,
            readerKey: Math.random().toString()
        }
    }
/*
nombre	apellido	telefono	email	cuit	ciudad	codigo	empresa
 */

    csvHeaders = [
        {
            label: 'Nombre', title: 'Nombre', key: 'nombre', dataIndex: 'nombre'
        },
        {
            label: 'Apellido', title: 'Apellido', key: 'apellido', dataIndex: 'apellido'
        },
        {
            label: 'Teléfono', title: 'Teléfono', key: 'telefono', dataIndex: 'telefono'
        },
        {
            label: 'Email', title: 'Email', key: 'email', dataIndex: 'email'
        },
        {
            label: 'CUIT', title: 'CUIT', key: 'cuit', dataIndex: 'cuit'
        },
        {
            label: 'Ciudad', title: 'Ciudad', key: 'ciudad', dataIndex: 'ciudad'
        },
        {
            label: 'Código', title: 'Código', key: 'codigo', dataIndex: 'codigo'
        },
        // {
        //     label: 'Empresa', title: 'Empresa', key: 'empresa', dataIndex: 'empresa'
        // },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record, index) => {
                return {
                    children: <>
                        <Button onClick={() => {
                            console.log(record);
                            this.setState({
                                modalVisible: true,
                                indexEditing: index,
                                recordEditing: record
                            })
                        }}>
                            Editar
                        </Button>
                    </>
                }
            }
        }

    ];


    deleteCSV = (record, index) => {
        const state = {...this.state};
        state.csv.splice(index, 1);
        this.setState(state);
    }

    componentDidMount = () => {
        Promise.all([
            this.loadUserData()
        ]).then(() => {
            this.setState({loading: false})
        })
    }



    loadUserData = async () => {
        const [response, user] = await Promise.all([
            Auth.currentSession(),
            Auth.currentUserInfo()
        ]);

        this.userData = await API.get(
            'test',
            '/root/admindashboard/' + user.username,
            {
                headers: {
                    Authorization: response.getIdToken().getJwtToken()
                }
            }
        );
    }


    updateData(field, value) {
        const data = {...this.state}
        data[field] = value
        this.setState({...data})
    }


    uploadBatch = async () => {
        this.setState({uploadingCsv: true});

        const errors = this.state.csv.map((data, i) => {

            if(!data.procesar){
                return;
            }

            const fila = i + 1;
            if(!data.nombre){
                return 'El nombre es requerido en fila ' + fila
            }
            if(!data.apellido){
                return 'El nombre es requerido en fila ' + fila
            }
            if(!data.email){
                return 'El email es requerido en fila ' + fila
            }
            if(data.telefono && !data.telefono.startsWith('+')) {
                return 'El número de télefono debe tener código de pais (ej. +54) en fila ' + fila
            }
        }).filter(x => !!x);


        if(errors.length){
            message.error(errors[0]);
            this.setState({uploadingCsv: false});
            return;
        }


        Storage.put('usersBatch/' + this.userData.cuit + '.csv', JSON.stringify(this.state.csv), {
            level: 'public',
            contentType: 'text/csv'
        }).then(response => {
            this.componentDidMount();
            message.success("El lote se está procesando. En unos minutos podrá ver los usuarios desde la vista general", 4)
            this.setState({csv: [], data: [], selectedKeys: []})
            this.setState({uploadingCsv: false})
        }).catch(err => {
            message.error("Error al subir lote")
            console.log(err)
        })
    }


    handleCancelModal = () => {
        this.setState({modalVisible: false, modalBajarFacturasVisible: false})
    }

    saveEditing = () => {
        const csv = [...this.state.csv];
        csv[this.state.indexEditing] = this.state.recordEditing;
        const data = [...this.state.data];
        data[this.state.indexEditing] = this.state.recordEditing;
        this.setState({modalVisible: false, csv, data})
    }


    render() {

        if (this.state.loading) {
            return (
                <>
                    <Row/>
                    <Row type="flex" justify="space-around" align="middle" style={{marginTop: '150px'}}>
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                    <Row/>
                </>
            )
        } else if (this.state.step === 'newBatch') {

            return (
                <BaseAdminLite
                    selected="load-users-batch"
                >

                    <Row>
                        <Card style={{marginTop: 20}}>
                            <div key={this.state.readerKey}>
                                <CSVReader
                                    disabled={!this.state.enableUpload}
                                    onFileLoaded={(data) => {
                                        const selectedKeys = [];
                                        let rows = data.map((value, index) => {
                                            value["key"] = index
                                            value['procesar'] = true;
                                            value['empresa'] = this.userData.cuit;
                                            selectedKeys.push(index);
                                            return value
                                        })
                                        this.setState({csv: rows, data: data, selectedKeys, readerKey: Math.random().toString()})
                                    }}
                                    parserOptions={{
                                        header: true,
                                        skipEmptyLines: true,
                                        transformHeader: header =>
                                            header
                                                .toLowerCase()
                                                .replace(/\W/g, '_')
                                    }}
                                    cssClass="ant-btn ant-btn-primary"
                                    label="Importar CSV"
                                    onError={(e) => {
                                        this.setState({csv: []});
                                        console.error(e);
                                        return (
                                            message.error('Error en archivo CSV')
                                        )
                                    }}
                                />
                            </div>
                            <Modal
                                title={"Editar"}
                                width={700}
                                visible={this.state.modalVisible}
                                onOk={this.saveEditing}
                                onCancel={this.handleCancelModal}
                                footer={[
                                    <Button key="back" onClick={this.handleCancelModal}>
                                        Cancelar
                                    </Button>,
                                    <Button key="submit" type="primary" onClick={this.saveEditing}>
                                        Guardar
                                    </Button>,
                                ]}
                            >
                                <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                                    {this.state.recordEditing && this.csvHeaders.filter(c => c.label).map(c => (
                                        <div key={c.label} style={{marginTop: 5, marginRight: 10}}>
                                            <label>{c.label}</label><br/>
                                            <Input style={{width: 300}}
                                                   key={c.dataIndex}
                                                   value={this.state.recordEditing[c.dataIndex]}
                                                   onChange={e => {
                                                       const record = {...(this.state.recordEditing)};
                                                       record[c.dataIndex] = e.target.value;
                                                       this.setState({recordEditing: record})
                                                   }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </Modal>
                            <Table
                                columns={this.csvHeaders}
                                dataSource={this.state.csv}
                                rowClassName={(data, index) => data.procesar ? 'procesar' : 'no-procesar'}
                                rowSelection={{
                                    selectedRowKeys: this.state.selectedKeys,
                                    onChange: selectedKeys => this.setState({selectedKeys}),
                                    onSelect: record => {
                                        this.state.csv[record.key].procesar = !this.state.csv[record.key].procesar;
                                        this.setState({csv: [...this.state.csv]})
                                    }
                                }}
                                scroll={{x: "max-content"}}
                                style={{margin: "20px"}}
                            />
                            <Button.Group style={{marginTop: "15px", marginLeft: "15px"}}>
                                <Button
                                    type="primary"
                                    disabled={!this.state.csv.some(x => x.procesar)}
                                    onClick={(e) => this.uploadBatch()}
                                    loading={this.state.uploadingCsv}
                                >
                                    Subir lote
                                </Button>
                            </Button.Group>
                        </Card>
                    </Row>
                </BaseAdminLite>
            );
        }
    }
}


const meses = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', "Junio", 'Julio', "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

const UserBatch = Form.create({name: 'uploadInvoices'})(LoadUsersBatch)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserBatch))
